import { render, staticRenderFns } from "./suitch-doorlock.vue?vue&type=template&id=797458ea&"
import script from "./suitch-doorlock.vue?vue&type=script&lang=js&"
export * from "./suitch-doorlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports